import { Injectable } from '@angular/core';

@Injectable()
export class LocalPagedDataManager {


    /**
     *this method contains logic to filter records based on search criteria
     *
     */
    public filterDataForSearchCriteria(searchCriteria, fullData, filterCondition?: any) {
        const filteredData = fullData.filter(rowData => {
            if (rowData && rowData.cells) {
                return this.doesRowSatisfyCriteria(searchCriteria, rowData, fullData, filterCondition);
            } else {
                return false;
            }
        });
        return filteredData;
    }

    protected doesRowSatisfyCriteria(searchCriteria, rowData, fullData, filterCondition?: any) {
        const filterConditions = searchCriteria.conditions;
        const searchCriteriaColumnName = [];
        let patternMatch = true;
        let prevLogicalOperation = '';
        let logicalOperation = '';
        let orConditionMatch = false;
        const comparisonOperators = ['<', '>', '<=', '>='];
        filterConditions.forEach(condition => {
            condition.clauses.forEach((clause: any) => {
                if(clause.logicalOperation === 'OR'){
                    logicalOperation = clause.logicalOperation;
                }
            });
        });

        filterConditions.forEach(condition => {
            if (!condition.clauses) {
                return false;
            }
            condition.clauses.forEach((clause: any) => {
                if (clause.value && clause.value !== '*') { // For handling value = * in search criteria
                    const columnName = clause.column;
                    let columnValue: any;
                    let pattern: RegExp;
                    // [LFWM-2885] - For handling like operator of column filter
                    if (clause.operation === 'like' && clause.value.includes('%')) {
                        columnValue = clause.value.replaceAll('%', '');
                        /* sequence of charaters that can be in any place staring, ending or in middle of the cell value
                        if clause.value - %5% - cell value of clause.column of row should contains 5 */
                        if (clause.value.startsWith('%') && clause.value.endsWith('%')) {
                            pattern = new RegExp(columnValue, 'i');
                        } else if (clause.value.startsWith('%')) {
                            /* should match with end characters of the input
                            if clause.value - %5 - cell value of clause.column of row should ends with 5 */
                            pattern = new RegExp(columnValue + '$', 'i');
                        } else if (clause.value.endsWith('%')) {
                            /* should match with starting characters of the input
                            if clause.value - 5% - cell value of clause.column of row should starts with 5 */
                            pattern = new RegExp('^' + columnValue, 'i');
                        }
                    } else if(clause.operation === 'contains'){
                        pattern = new RegExp(clause.value,'i');
                    } else {
                        columnValue = clause.value;
                        pattern = new RegExp('^' + columnValue, 'i');
                    }
                    if (rowData.cells[columnName] && rowData.cells[columnName].cVal) {
                        /*LFWM - 2323 Changes done to enable sorting, string matching
                         and search with different operators in search filter*/

                        // LFWM - 2323 OR - logical operation in search filter
                        if (searchCriteriaColumnName.includes(columnName) &&
                            prevLogicalOperation === 'OR') {
                            prevLogicalOperation = condition.logicalOperation;
                            return true;
                        }
                        //LFWM-3862, if theres no filterCondition, then its for sorting
                        if(logicalOperation === 'OR' && !filterCondition){
                            patternMatch = true;
                            return true;
                        }

                        // LFWM - 2323 OR - logical operation in search filter
                        if (!pattern.test(rowData.cells[columnName].cVal)) {
                            let rowSatisfyOrCOndition = false;
                            filterConditions.forEach(searchCondition => {
                                searchCondition.clauses.forEach(searchClause => {
                                    if (searchClause.value && searchClause.value !== '*') {
                                        // LFWM - 3351 records were missing while doing pagination/sorting
                                        if (searchClause.operation === '>=' || searchClause.operation === '<='
                                        || searchClause.operation === '>' || searchClause.operation === '<' ||
                                            searchClause.operation === 'between' || searchClause.operation === '<>') {
                                                if (searchClause.operation === '<>') {
                                                    if (searchClause.column === columnName &&
                                                        (rowData.cells[searchClause.column].cVal !== columnValue )) {
                                                        rowSatisfyOrCOndition = true;
                                                        return true;
                                                    }
                                                }
                                            if (searchClause.column === columnName &&
                                                (rowData.cells[searchClause.column].cVal >= columnValue ||
                                                    rowData.cells[searchClause.column].cVal <= columnValue ||
                                                    rowData.cells[searchClause.column].cVal > columnValue ||
                                                    rowData.cells[searchClause.column].cVal < columnValue)) {
                                                rowSatisfyOrCOndition = true;
                                                return true;
                                            }
                                        } else if(logicalOperation === 'OR' && filterCondition ){ 
                                            //LFWM-3862 rowSatisfyOrCOndition and orConditionMatch is set to true
                                            // when the value of filter column matches with row value.
                                            filterCondition.clauses.forEach(fliterClause => {
                                                const filterPattern = new RegExp('^' + fliterClause.value, 'i');
                                                if (filterPattern.test(rowData.cells[fliterClause.column].cVal)) {
                                                    rowSatisfyOrCOndition = true;
                                                    orConditionMatch = true;  
                                                }     
                                            });
                                            return true;
                                        }else {
                                            const orConditionPattern = new RegExp('^' + searchClause.value, 'i');
                                            if (searchClause.column === columnName && searchClause.value !== columnValue
                                                && orConditionPattern.test(rowData.cells[searchClause.column].cVal)) {
                                                rowSatisfyOrCOndition = true;
                                                return true;
                                            }    
                                            //LFWM-3862 commented out the code for LFWM-3862 and LFWM-3863                                    
                                            //else if (searchClause.column === columnName && searchClause.value === columnValue
                                            //     && rowData.cells[searchClause.column].cVal) {
                                            //     rowSatisfyOrCOndition = true;
                                            //     return true;
                                            // } else {

                                            // }
                                        }
                                    }
                                });
                                if (rowSatisfyOrCOndition) {
                                    return true;
                                }
                            });
                            prevLogicalOperation = condition.logicalOperation;
                            if (!rowSatisfyOrCOndition) {
                                patternMatch = false;
                                return false;
                            }
                            return true;
                        }

                        // LFWM - 2323 contains and like operation in search filter
                        if ((clause.operation === 'contains' || clause.operation === 'like')
                            && rowData.cells[columnName].cVal.includes(columnValue)) {
                            prevLogicalOperation = condition.logicalOperation;
                            searchCriteriaColumnName.push(columnName);
                            return true;
                        }

                        // LFWM - 2323 between operation in search filter
                        if (clause.operation === 'between' && rowData.cells[columnName].cVal.trim() >= columnValue
                            && rowData.cells[columnName].cVal.trim() <= clause.value1) {
                            prevLogicalOperation = condition.logicalOperation;
                            searchCriteriaColumnName.push(columnName);
                            return true;
                        }

                        // LFWM - 2323 comparisonOperators('<', '>', '<=', '>=') operation in search filter
                        if (comparisonOperators.includes(clause.operation)) {
                            if (clause.operation === '>' && rowData.cells[columnName].cVal.trim() > columnValue) {
                                prevLogicalOperation = condition.logicalOperation;
                                searchCriteriaColumnName.push(columnName);
                                return true;
                            }
                            if (clause.operation === '<' && rowData.cells[columnName].cVal.trim() < columnValue) {
                                prevLogicalOperation = condition.logicalOperation;
                                searchCriteriaColumnName.push(columnName);
                                return true;
                            }
                            if (clause.operation === '>=' && rowData.cells[columnName].cVal.trim() >= columnValue) {
                                prevLogicalOperation = condition.logicalOperation;
                                searchCriteriaColumnName.push(columnName);
                                return true;
                            }
                            if (clause.operation === '<=' && rowData.cells[columnName].cVal.trim() <= columnValue) {
                                prevLogicalOperation = condition.logicalOperation;
                                searchCriteriaColumnName.push(columnName);
                                return true;
                            }
                        }
                        if (!pattern.test(rowData.cells[columnName].cVal) && orConditionMatch !== true ) {
                            patternMatch = false;
                            prevLogicalOperation = condition.logicalOperation;
                            return false;
                        }
                        prevLogicalOperation = condition.logicalOperation;
                        searchCriteriaColumnName.push(columnName);
                    }
                }
            });
            if (!patternMatch) {
                return false;
            }
        });
        return patternMatch;
    }

    // method used to sort the column
    public sortColumn(rows: any[], sortColumnMetaData: any, sortOrder: number) {
        if (!sortColumnMetaData || ((sortOrder !== 1) && (sortOrder !== 0)) || !rows || rows.length === 0) {
            // if any of the inputs is invalid, do not sort
            return;
        }
        const reA = /[^a-zA-Z]/g;
        const reN = /[^0-9]/g;
        const columnName = sortColumnMetaData.propertyName;
        const sortColumnType = sortColumnMetaData.displayType;
        const sortColumnDatatype = sortColumnMetaData.dataType;
        /* LFWM 1466 - If the data type of column to be sorted is Integer then,
        its cVal is typecasted to Integer before comparison for proper sorting */
        if (sortOrder === 0) { // ascending order
            rows.sort((a: any, b: any) => {
                if (sortColumnDatatype !== 'Date') { // [LFWM-2888][To check whether the particular field is Date]
                    if (sortColumnDatatype === 'Integer') {
                        if (+a.cells[columnName].cVal < +b.cells[columnName].cVal) {
                            return -1;
                        } else if (+a.cells[columnName].cVal > +b.cells[columnName].cVal) {
                            return 1;
                        } else {
                            return 0;
                        }
                    } else {
                        //LFWM-3290 sorting the values in ascending order
                        const value1 = a.cells[columnName].cVal;
                        const value2 = b.cells[columnName].cVal;
                        if (!value1)
                            return -1;
                        if (!value2)
                            return 1;
                        return value1.toLowerCase().localeCompare(value2.toLowerCase());
                        // const replacedVAr1 = value1.replace(reA, '');
                        // const replacedVAr2 = value2.replace(reA, '');
                        // if (replacedVAr1 === replacedVAr2) {
                        //     const replaceVAr1 = parseInt(value1.replace(reN, ''), 10);
                        //     const replaceVAr2 = parseInt(value2.replace(reN, ''), 10);
                        //     return replaceVAr1 === replaceVAr2 ? 0 : replaceVAr1 < replaceVAr2 ? 1 : -1;
                        // } else {
                        //     if (replacedVAr1 < replacedVAr2) {
                        //         return 1;
                        //     } else if (replacedVAr1 > replacedVAr2) {
                        //         return -1;
                        //     } else {
                        //         return 0;
                        //     }

                        // }
                    }
                } else {
                    if (a.cells[columnName].cVal === null) {
                        return 1;
                    } else if (b.cells[columnName].cVal === null) {
                        return -1;
                    } else if (a.cells[columnName].cVal === b.cells[columnName].cVal) {
                        return 0;
                    } else if (a.cells[columnName].cVal !== null && b.cells[columnName].cVal !== null) {
                        let aDate: Date;
                        let bDate: Date;
                        aDate = new Date(a.cells[columnName].cVal);
                        bDate = new Date(b.cells[columnName].cVal);
                        return (aDate > bDate) ? -1 : ((bDate > aDate) ? 1 : 0);
                    }
                }
            });
        } else if (sortOrder === 1) { // descending order
            rows.sort((a: any, b: any) => {
                if (sortColumnDatatype !== 'Date') { // [LFWM-2888][To check whether the particular field is Date]
                    if (sortColumnDatatype === 'Integer') {
                        if (+a.cells[columnName].cVal < +b.cells[columnName].cVal) {
                            return 1;
                        } else if (+a.cells[columnName].cVal > +b.cells[columnName].cVal) {
                            return -1;
                        } else {
                            return 0;
                        }
                    } else {
                        //LFWM-3290 sorting the values in descending order
                        const value1 = a.cells[columnName].cVal;
                        const value2 = b.cells[columnName].cVal;
                        if (!value1)
                            return 1;
                        if (!value2)
                            return -1;
                        return -value1.toLowerCase().localeCompare(value2.toLowerCase());  
                        // const replacedVAr1 = a.cells[columnName].cVal.replace(reA, '');
                        // const replacedVAr2 = b.cells[columnName].cVal.replace(reA, '');
                        // if (replacedVAr1 === replacedVAr2) {
                        //     const replaceVAr1 = parseInt(a.cells[columnName].cVal.replace(reN, ''), 10);
                        //     const replaceVAr2 = parseInt(b.cells[columnName].cVal.replace(reN, ''), 10);
                        //     return replaceVAr1 === replaceVAr2 ? 0 : replaceVAr1 < replaceVAr2 ? -1 : 1;
                        // } else {
                        //     if (replacedVAr1 < replacedVAr2) {
                        //         return -1;
                        //     } else if (replacedVAr1 > replacedVAr2) {
                        //         return 1;
                        //     } else {
                        //         return 0;
                        //     }
                        // }
                    }
                } else {
                    if (a.cells[columnName].cVal === null) {
                        return 1;
                    } else if (b.cells[columnName].cVal === null) {
                        return -1;
                    } else if (a.cells[columnName].cVal === b.cells[columnName].cVal) {
                        return 0;
                    } else if (a.cells[columnName].cVal !== null && b.cells[columnName].cVal !== null) {
                        let aDate: Date;
                        let bDate: Date;
                        aDate = new Date(a.cells[columnName].cVal);
                        bDate = new Date(b[columnName.prop]);
                        return (aDate > bDate) ? 1 : ((bDate > aDate) ? -1 : 0);
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/local-paged-data-manager.service.ts